<!-- <h4 class="title">Follow up Save</h4> -->
<mat-icon style="text-align: right;width: 100%;margin-bottom: 13px;margin-top: -10px;" mat-button (click)="close()">close</mat-icon>

<div class="row">
    <div class="col-md-12">
        <h4 class="title-f">Collection Recording</h4>
        <div class="card-box">
            <div class="row" style="padding: 0px 0px 23px 10px;">
              <form [formGroup]="CollectionForm">
                <div class="form-row">
                  <div class="col-md-3">
                    <h5 class="form-lable">Loan No./Account No.:</h5>
                    <input type="text" pInputText placeholder="" formControlName="account_no_collection" >
                  </div>
                  <div class="col-md-3">
                    <h5 class="form-lable">Customer Name:</h5>
                    <input type="text" pInputText placeholder="" formControlName="customer_name_collection">
                  </div>
                  <div class="col-md-3">
                    <h5 class="form-lable">DPD>=:</h5>
                    <input type="text" pInputText placeholder="" formControlName="dpd_collection">
                  </div>
                  <div class="col-md-3">
                    <h5 class="form-lable">Card Number:</h5>
                    <input type="text" pInputText placeholder="" formControlName="card_number_collection">
                  </div>
                  <div class="col-md-3">
                    <h5 class="form-lable">Branch:</h5>
                    <input type="text" pInputText placeholder="" formControlName="branch_collection">
                  </div>
                  <div class="col-md-3">
                    <h5 class="form-lable">Product:</h5>
                    <input type="text" pInputText placeholder="" formControlName="product_collection">
                  </div>
                  <div class="col-md-3">
                    <h5 class="form-lable">Bucket:</h5>
                    <input type="text" pInputText placeholder="" formControlName="bucket_collection">
                  </div>
                  <div class="col-md-3">
                    <h5 class="form-lable">Queue:</h5>
                    <input type="text" pInputText placeholder="" formControlName="queue_collection">
                  </div>
                  <div class="col-md-3">
                    <h5 class="form-lable">Car Type:</h5>
                    <input type="text" pInputText placeholder="" formControlName="cardtype_collection">
                  </div>
                  <div class="col-md-3">
                    <h5 class="form-lable">POS / Curr Acc Bal:</h5>
                    <input type="text" pInputText placeholder="" formControlName="pos_collection">
                  </div>
                  <div class="col-md-3">
                    <h5 class="form-lable">Sub Product Code:</h5>
                    <input type="text" pInputText placeholder="" formControlName="subproduct_code_collection">
                  </div>
                  <div class="col-md-3">
                    <h5 class="form-lable">Scheme:</h5>
                    <input type="text" pInputText placeholder="" formControlName="scheme_collection">
                  </div>
                </div>
              </form>
                
                <div class="col-md-3 mt-20">
                    <button type="button" class="btn btn-primary" (click)="addCollection()">ADD</button>
                </div>
            
              </div>

        </div>
    </div>
</div>



<ng-container>

    <!-- <h4 class="title">Collection Recording</h4> -->
  
    <div class="doc-table">
        <div class="card-box"> <p-table [value]="CollectionList | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="false" [rows]="5"
            [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [globalFilterFields]="['type']">
            <ng-template pTemplate="header">
                <tr style="text-align: center;">
                    <th>S.No</th>
                    <th>Loan No./ Account No. </th>
                    <th>Customer Name</th>
                    <th>DPD>= </th>
                    <th>Card Number </th>
                    <th>Branch </th>
                    <th>Product </th>
                    <th>Bucket </th>
                    <th>Queue </th>
                    <th>Car Type </th>
                    <th>POS / Curr Acc Bal  </th>
                    <th>Sub Product Code </th>
                    <th>Scheme</th>
                </tr>
                <tr style="text-align: center;" *ngFor="let item of CollectionList; let i = index;">
                    <td>{{i+1}}</td>
                    <td (click)="show()"><a class="link-a">{{item.account_no_collection}}</a></td>
                    <td>{{item.customer_name_collection}}</td>
                    <td>{{item.dpd_collection}}</td>
                    <td>{{item.card_number_collection}}</td>
                    <td>{{item.branch_collection}}</td>
                    <td>{{item.bucket_collection}}</td>
                    <td>{{item.product_collection}}</td>
                    <td>{{item.queue_collection}}</td>
                    <td>{{item.cardtype_collection}}</td>
                    <td>{{item.pos_collection}}</td>
                    <td>{{item.subproduct_code_collection}}</td>
                    <td>{{item.scheme_collection}}</td>
                </tr>
            </ng-template>
         </p-table>  </div>
    </div>
    <br>

</ng-container>
